import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { TipoIntervento } from '../models/tipoIntervento.model';


@Injectable({
  providedIn: 'root',
})
export class TipiInterventoService{
  apiUrl: string = environment.apiUrl +"tipo-intervento";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}


  get(): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };

    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }

  getByIDAreaCompetenza(idAreaCompetenza:number): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };

    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?idAreaCompetenza="+idAreaCompetenza, httpOptions);
  }
  getByLabelAreaCompetenza(areaCompetenza:string): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };

    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"?areaCompetenza="+areaCompetenza, httpOptions);
  }

  crea(tipoIntervento:TipoIntervento): Observable<any> {
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, tipoIntervento, httpOptions);

  }


  modifica(tipoIntervento:TipoIntervento): Observable<any> {

    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+tipoIntervento.id, tipoIntervento, httpOptions);
  }

  elimina(idTipoIntervento:string): Observable<any> {
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idTipoIntervento, httpOptions);

  }




}
